import React, { useContext, useState } from 'react';

import { WizardContext } from './hooks/WizardContext';
import MobileSection from './MobileSection';

import * as S from './styles/MobilePage.styles';

const MobilePage = () => {

    const { layout, activePage, globalStyles } = useContext(WizardContext);
    const [dropIndicator, setDropIndicator] = useState(null);

    const activePageLayout = activePage ? layout[activePage.id] : null;
    const marginSpacing = globalStyles?.marginSpacing || 0;
    const maxAppWidth = globalStyles?.maxAppWidth || '100%';
 
    if (!activePageLayout) {
        return <div>No layout for this page yet...</div>;
    }

    const handleMouseLeave = () => {
        setDropIndicator(null);
    };

    if (!activePageLayout || activePageLayout.length === 0) {
       return (
           <S.PageWrapper maxWidth={maxAppWidth} gapSize={marginSpacing}>
               <S.PlaceholderWrapper>
                   <S.PlaceholderText>Add a New Section to begin...</S.PlaceholderText>
                </S.PlaceholderWrapper>
           </S.PageWrapper>
        );
   }

    return (
        <S.PageWrapper maxWidth={maxAppWidth} gapSize={marginSpacing} onMouseLeave={handleMouseLeave}>
            {activePageLayout.map((section, index) => (
                <MobileSection
                    key={section.id}
                    index={index}
                    section={section}
                    dropIndicator={dropIndicator}
                    setDropIndicator={setDropIndicator}
                />
            ))}
        </S.PageWrapper>
    );
};

export default MobilePage;